<div [class.active]="isActive" [attr.class]="getPlateType()">
  <span>{{ text }}</span>
</div>
